import { gql } from "@apollo/client";

export const REMOVE_TEAM_MEMBER_MUTATION = gql`
  mutation RemoveTeamMemberMutation($removeTeamMemberData: RemoveTeamMemberData!) {
    removeTeamMember(data: $removeTeamMemberData)
  }
`;
